import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Industry {
  id: string;
  name: string;
  icon: string;
}

export default function IndustriesShowcase() {
  const industries: Industry[] = [
  { id: 'restaurants', name: 'Restaurants', icon: 'BuildingStorefrontIcon' },
  { id: 'cafes', name: 'Cafes', icon: 'CakeIcon' },
  { id: 'hospitals', name: 'Hospitals', icon: 'HeartIcon' },
  { id: 'corporate', name: 'Corporate', icon: 'BriefcaseIcon' },
  { id: 'hotels', name: 'Hotels', icon: 'BuildingOffice2Icon' },
  { id: 'electronics', name: 'Electronics', icon: 'ComputerDesktopIcon' },
  { id: 'retail', name: 'Retail', icon: 'ShoppingBagIcon' },
  { id: 'education', name: 'Education', icon: 'AcademicCapIcon' }];


  return (
    <section className="py-20 md:py-32 bg-zinc-950 border-y border-zinc-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 reveal">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-[2px] h-4 bg-amber-500" />
            <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-400">
              Industries We Serve
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-white">
            50+ Industries,<br />One Expertise
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            From restaurants to hospitals, we understand your industry's unique needs.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {industries.map((industry, idx) =>
          <div
            key={industry.id}
            className="group bg-zinc-900 border border-zinc-800 rounded-2xl p-8 text-center hover:border-amber-500/30 transition-all hover:scale-105 glow-hover reveal"
            style={{ transitionDelay: `${idx * 50}ms` }}>
            
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center text-zinc-500 bg-zinc-800 rounded-xl group-hover:bg-amber-500 group-hover:text-white transition-all">
                <Icon name={industry.icon as any} size={32} />
              </div>
              <h3 className="text-sm font-bold text-zinc-300 group-hover:text-white transition-colors">
                {industry.name}
              </h3>
            </div>
          )}
        </div>

        {/* Industry Images Showcase */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12 reveal">
          {[
          { src: "https://img.rocket.new/generatedImages/rocket_gen_img_128760963-1766473829050.png", alt: 'Modern restaurant interior with elegant dining setup and ambiance', industry: 'Restaurants' },
          { src: "https://images.unsplash.com/photo-1639338085998-d42088d4560a", alt: 'Cozy cafe atmosphere with coffee and pastries display', industry: 'Cafes' },
          { src: "https://img.rocket.new/generatedImages/rocket_gen_img_167a2ecf3-1768494900420.png", alt: 'Modern hospital facility with advanced medical equipment and care', industry: 'Hospitals' },
          { src: "https://img.rocket.new/generatedImages/rocket_gen_img_101ffe301-1766575390598.png", alt: 'Corporate office building with modern architecture and business environment', industry: 'Corporate' },
          { src: "https://images.unsplash.com/photo-1660268562197-902bc82a266d", alt: 'Luxury hotel lobby with premium hospitality services and amenities', industry: 'Hotels' },
          { src: "https://img.rocket.new/generatedImages/rocket_gen_img_129417114-1765586202433.png", alt: 'Electronics store showcasing latest technology and gadgets', industry: 'Electronics' },
          { src: "https://img.rocket.new/generatedImages/rocket_gen_img_124bd2186-1766501782763.png", alt: 'Retail store with fashion and lifestyle products display', industry: 'Retail' },
          { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1501a81af-1771428319436.png", alt: 'Educational institution with students learning and academic environment', industry: 'Education' }]?.
          map((img, idx) =>
          <div
            key={idx}
            className="relative aspect-[4/3] rounded-2xl overflow-hidden group hover-lift"
            style={{ animationDelay: `${idx * 80}ms` }}>
            
              <AppImage
              src={img?.src}
              alt={img?.alt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
            
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-4 left-4 text-white font-bold">{img?.industry}</div>
            </div>
          )}
        </div>

        <div className="text-center mt-12 reveal">
          <p className="text-zinc-500 text-sm">
            And many more... <span className="text-amber-500 font-semibold">Let's discuss your industry</span>
          </p>
        </div>
      </div>
    </section>);

}